/**
 * Format a number as EUR value with Croatian locale.
 *** Note: Ensure that the browser/environment supports the 'Intl.NumberFormat' object.
 * @param {number} value - The numeric value to be formatted.
 * @param {string} currency - Currency string, defaults to "EUR".
 * @param {number} minimumFractionDigits - Minimum number of fraction digits, defaults to 2.
 * @param {number} maximumFractionDigits - Maximum number of fraction digits, defaults to 2.
 * @returns {string} - The formatted EUR value as a string.
 */
export const formatCurrency = (
  value: number,
  currency = "EUR",
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
): string => {
  try {
    // Use the toLocaleString method with 'hr-HR' (Croatian) locale and 'currency' style to format as EUR.
    return value?.toLocaleString("hr-HR", {
      style: "currency",
      currency,
      minimumFractionDigits,
      maximumFractionDigits,
    });
  } catch (error) {
    console.error("Error formatting EUR value:", error instanceof Error ? error.message : error);
    return value.toString();
  }
};
